// admin_tools/frontend/src/components/InstitutionSelector.js
//
// Header dropdown to choose the active institution. Persists the choice (via
// institutionFetch) and reloads so every tab refetches under the new institution.
import React, { useState, useEffect } from 'react';
import { getInstitutionId, setInstitutionId } from '../institutionFetch';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

export default function InstitutionSelector() {
  const [institutions, setInstitutions] = useState([]);
  const [selected] = useState(getInstitutionId());

  useEffect(() => {
    fetch(`${API_URL}/api/institutions`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => setInstitutions(Array.isArray(data) ? data : []))
      .catch(() => setInstitutions([]));
  }, []);

  const onChange = (e) => {
    setInstitutionId(e.target.value);
    window.location.reload(); // refetch every tab under the newly selected institution
  };

  if (!institutions.length) return null;

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="institution-select" className="text-sm text-gray-600">
        Institution:
      </label>
      <select
        id="institution-select"
        value={selected}
        onChange={onChange}
        className="border border-gray-300 rounded px-2 py-1 text-sm"
      >
        {institutions.map((inst) => (
          <option key={inst.id} value={inst.id}>
            {inst.name}
          </option>
        ))}
      </select>
    </div>
  );
}
